import { NavigateFunction, useLocation, useNavigate } from "react-router-dom";

import { history } from "src/navigation/store";
import { makeHierarchicalPath } from "./Link";
import { FeScheme } from "src/types/navigation";

const handler =
  <T>(mode: "replace" | "detect", navigate: NavigateFunction, from: string) =>
  (schemes: T, state?: Record<string, unknown>) => {
    const url = schemes as never;
    const to = makeHierarchicalPath(
      history.location,
      Array.isArray(url) ? url : [url],
      mode
    );

    if (to) {
      navigate(to, { state: { ...state, from } });
    }
  };

export const useRedirect = () => {
  const navigate = useNavigate();
  const location = useLocation();

  return {
    redirect: handler<FeScheme>("replace", navigate, location.pathname),
  };
};
